import { PageHeader } from './PageHeader'
import { useT } from '../i18n'

/**
 * Shared confirmation screen shown after a weekly-event submission is
 * complete (Colorful picks, IET dish, Three Step solution). Replaces the
 * old behaviour of sitting on a finished form full of check marks.
 */
export function WeeklySubmittedScreen({
  title = 'Weekly',
  accent = '#A3E635',
  message = "You're entered in this week's event. Winners are revealed next Monday. Good luck!",
  onBackToMenu,
  onReview,
  reviewLabel = 'Review / edit my entry',
}: {
  title?: string
  /** Accent hex for the success ring. */
  accent?: string
  message?: string
  onBackToMenu: () => void
  /** Optional — go back to the form to tweak before the deadline. */
  onReview?: () => void
  reviewLabel?: string
}) {
  const t = useT()
  return (
    <div className="screen">
      <PageHeader title={title} onBack={onBackToMenu} />
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center gap-4">
        <div
          className="w-24 h-24 rounded-full flex items-center justify-center text-5xl"
          style={{ backgroundColor: `${accent}22`, border: `3px solid ${accent}` }}
        >
          ✅
        </div>
        <h2 className="font-display text-3xl font-black text-brand-text">{t('Submission received!')}</h2>
        <p className="text-brand-muted max-w-xs leading-relaxed">{t(message)}</p>
      </div>
      <div className="floating-actions space-y-2">
        {onReview && (
          <button onClick={onReview} className="btn-outline">
            {t(reviewLabel)}
          </button>
        )}
        <button onClick={onBackToMenu} className="btn-primary">{t('Back to menu')}</button>
      </div>
    </div>
  )
}
